import React from "react";
import {Card, Col, Row, Container, Table} from "react-bootstrap";
import {useLaravelReactI18n} from "laravel-react-i18n";
import {usePage} from "@inertiajs/react";

export default function Dashboard(props) {
    const {t} = useLaravelReactI18n();
    const {balances,lastTransactions,toZeroReplacements,fatherName,motherName} = usePage().props;

    return (<>
            <div className="mt-5 d-lg-flex d-none justify-content-center">
                <h1>{props.appname}</h1>
            </div>
            <div className="d-flex justify-content-center">
                <h5>{t('Zeitraum ab: :startDate', {startDate: balances['startDate']})}</h5>
            </div>
                <Container fluid="md">
                    <Row xs={1} md={3} className="g-4 pb-4">
                        <Col>
                            <Card bg={"secondary"} text="white" className="h-100">
                                <Card.Header><h6>{fatherName}</h6></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <span className={"expense fw-bold"}>{balances['fatherExpenses']}</span>
                                        </Col>
                                        <Col>
                                            <span className={"income fw-bold"}>{balances['fatherIncome']}</span>
                                        </Col>
                                        <Col>
                                            <span className={"fw-bold"}>{balances['fatherTotal']}</span>
                                        </Col>

                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card bg={"success"} text="white" className="h-100">
                                <Card.Header><h6>{t('total')}</h6></Card.Header>
                                <Card.Body>
                                    {balances['balance']}
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card bg={"primary"} text="white" className="h-100">
                                <Card.Header><h6>{motherName}</h6></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <span className={"expense fw-bold"}>{balances['motherExpenses']}</span>
                                        </Col>
                                        <Col>
                                            <span className={"income fw-bold"}>{balances['motherIncome']}</span>
                                        </Col>
                                        <Col>
                                            <span className={"fw-bold"}>{balances['motherTotal']}</span>
                                        </Col>

                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="g-4 pb-4">
                        <Col>
                            <Card bg={"light"} className="h-100">
                                <Card.Header><h6>{t('compensation payment')}</h6></Card.Header>
                                <Card.Body>
                                    <p>{t(':name1 has to pay :amount to :name2  to balance the account.', toZeroReplacements)}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card bg={"light"} className="h-100">
                                <Card.Header><h6>{t('Last transactions')}</h6></Card.Header>
                                <Table className="mb-0">
                                    <thead>
                                    <tr>
                                        <th>{t('date')}</th>
                                        <th>{t('who')}</th>
                                        <th>{t('description')}</th>
                                        <th>{t('type')}</th>
                                        <th>{t('amount')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {lastTransactions.map((transaction) => {
                                            return (<tr style={{cursor: 'pointer'}}>
                                                <td>{transaction.date}</td>
                                                <td>{transaction.user.name}</td>
                                                <td>{transaction.description}</td>
                                                <td>{t(transaction.type)}</td>
                                                <td><span className={transaction.type}>{transaction.amount}</span></td>
                                            </tr>);
                                        }
                                    )}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>
        </>
    );
}
